import { createSlice } from '@reduxjs/toolkit'

export interface isRemoconRedux {
  remoconModal: boolean
}

const initialState: isRemoconRedux = {
  remoconModal: false,
}
const remoconModalOpenSlice = createSlice({
  name: 'remoconModal',
  initialState,
  reducers: {
    toggleRemoconModal: (state) => {
      return {
        ...state,
        remoconModal: !state.remoconModal,
      }
    },
  },
})

export default remoconModalOpenSlice
export const { toggleRemoconModal } = remoconModalOpenSlice.actions
